export default "<div fxLayout=\"column\">\n  <button mat-button (click)=\"openCRM()\">Open CRM</button>\n</div>\n"